"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseButton = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var smallButton = function (theme) { return "\n  font-family: " + theme.typography.body.smallTextMain.fontFamily + ";\n  font-size: " + theme.typography.body.smallTextMain.fontSize + ";\n  font-weight: " + theme.typography.body.smallTextMain.fontWeight + ";\n  height: 32px;\n  line-height: " + theme.typography.body.smallTextMain.lineHeight + ";\n"; };
var mediumButton = function (theme) { return "\n  font-family: " + theme.typography.body.textMain.fontFamily + ";\n  font-size: " + theme.typography.body.textMain.fontSize + ";\n  font-weight: " + theme.typography.body.textMain.fontWeight + ";\n  height: 40px;\n  line-height: " + theme.typography.body.textMain.lineHeight + ";\n"; };
var largeButton = function (theme) { return "\n  font-family: " + theme.typography.body.textMain.fontFamily + ";\n  font-size: " + theme.typography.body.textMain.fontSize + ";\n  font-weight: " + theme.typography.body.textMain.fontWeight + ";\n  height: 48px;\n  line-height: " + theme.typography.body.textMain.lineHeight + ";\n"; };
var getButtonSize = function (_a) {
    var size = _a.size, theme = _a.theme;
    switch (size) {
        case 'small':
            return smallButton(theme);
        case 'medium':
            return mediumButton(theme);
        case 'large':
            return largeButton(theme);
        default:
            return smallButton(theme);
    }
};
exports.BaseButton = styled_components_1.default.button.attrs(function (_a) {
    var isDisabled = _a.isDisabled;
    return ({
        style: isDisabled === true ? {
            cursor: 'auto'
        } : undefined
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background-color: transparent;\n  border-radius: 2px;\n  cursor: pointer;\n  padding: 0 ", ";\n  outline: 0;\n  width: ", ";\n"], ["\n  ", "\n  background-color: transparent;\n  border-radius: 2px;\n  cursor: pointer;\n  padding: 0 ", ";\n  outline: 0;\n  width: ", ";\n"])), getButtonSize, function (_a) {
    var theme = _a.theme;
    return theme.space.s200;
}, function (_a) {
    var shouldFitToContainer = _a.shouldFitToContainer;
    return shouldFitToContainer === true ? '100%' : '';
});
var templateObject_1;
